import { EnvelopeIcon, PencilIcon, PhoneIcon } from "@heroicons/react/24/solid";
import { Contact } from "../../../../__generated__/graphql";
import { useUser } from "../../../../contexts/UserContext/hooks/useUser";
import { cn } from "../../../../lib/utils";
import Button from "../../../../components/Button";
import CreateContactModal from "../CreateContactModal";
import { useState } from "react";
import DeleteContactButton from "./components/DeleteContactButton";

export default function ContactItem({
  contact,
  onDelete,
}: {
  contact: Contact;
  onDelete: () => void;
}) {
  const { currentOrganization } = useUser();
  const isOwner = currentOrganization?.id === contact.organizationId;

  const [selectedContact, setSelectedContact] = useState<Contact | undefined>(
    undefined
  );

  return (
    <>
      <CreateContactModal
        contact={selectedContact}
        isOpen={!!selectedContact}
        onClose={() => {
          setSelectedContact(undefined);
        }}
      />

      <div
        key={contact.id}
        className={cn(
          "flex flex-col gap-2 bg-card rounded-md p-4 w-70 transition-all duration-300 border border-border"
        )}
      >
        <div className="flex flex-row gap-2 items-center justify-between">
          <div className="text-primary text-md font-bold break-words flex-1 min-w-0">
            {contact.name}
          </div>
          {isOwner ? (
            <div className="flex flex-row gap-2">
              <Button
                variant="secondary"
                className="text-sm text-secondary  hover:text-secondary/80 p-0"
                onClick={() => setSelectedContact(contact)}
              >
                <PencilIcon className="w-4 h-4" />
              </Button>
              <DeleteContactButton contactId={contact.id} onDelete={onDelete} />
            </div>
          ) : null}
        </div>

        <div className="flex flex-row gap-4 items-center">
          <PhoneIcon className="w-4 h-4 text-secondary" />
          <div className="text-secondary text-sm">
            {contact.phoneNumber && contact.phoneNumber.length > 0 ? (
              <a href={`tel:${contact.phoneNumber}`}>{contact.phoneNumber}</a>
            ) : (
              "-"
            )}
          </div>
        </div>

        <div className="flex flex-row gap-4 items-center">
          <EnvelopeIcon className="w-4 h-4 text-secondary" />
          <div className="text-secondary text-sm">
            {contact.email && contact.email.length > 0 ? (
              <a href={`mailto:${contact.email}`}>{contact.email}</a>
            ) : (
              "-"
            )}
          </div>
        </div>

        <div className="text-secondary text-xs line-clamp-2">
          {contact.description}
        </div>
      </div>
    </>
  );
}
